import axios from "axios";
import { toast } from "react-toastify";
const roundToTwoDecimals = (num) => {
  return Math.round(num * 100) / 100;
};

export const getCachedGoldPrice = async () => {
  const cachedData = localStorage.getItem("goldPriceData");
  const today = new Date().toISOString().split("T")[0];

  if (cachedData) {
    const parsed = JSON.parse(cachedData);
    if (parsed?.date === today && parsed?.basePrice24K) {
      return {
        "24K": { perGram: parsed.basePrice24K, perOunce: parsed.basePrice24KOz },
        "22K": { perGram: parsed.basePrice22K, perOunce: parsed.basePrice22KOz },
        "20K": { perGram: parsed.basePrice20K, perOunce: parsed.basePrice20KOz },
        "18K": { perGram: parsed.basePrice18K, perOunce: parsed.basePrice18KOz },
        "16K": { perGram: parsed.basePrice16K, perOunce: parsed.basePrice16KOz },
        "14K": { perGram: parsed.basePrice14K, perOunce: parsed.basePrice14KOz }
      };
    }
  }

  try {
    const response = await axios.get("https://api.gold-api.com/price/XAU");
    const pricePerOunce = response.data.price;

    if (!pricePerOunce) throw new Error("Gold price missing from API");
    const pricePerGram24K = pricePerOunce / 31.1035;
    const pricePerGram22K = (22 / 24) * pricePerGram24K;
    const pricePerGram20K = (20 / 24) * pricePerGram24K;
    const pricePerGram18K = (18 / 24) * pricePerGram24K;
    const pricePerGram16K = (16 / 24) * pricePerGram24K;
    const pricePerGram14K = (14 / 24) * pricePerGram24K;
    const prices = {
      basePrice24K: roundToTwoDecimals(pricePerGram24K),
      basePrice22K: roundToTwoDecimals(pricePerGram22K),
      basePrice20K: roundToTwoDecimals(pricePerGram20K),
      basePrice18K: roundToTwoDecimals(pricePerGram18K),
      basePrice16K: roundToTwoDecimals(pricePerGram16K),
      basePrice14K: roundToTwoDecimals(pricePerGram14K),
      basePrice24KOz: roundToTwoDecimals(pricePerOunce),
      basePrice22KOz: roundToTwoDecimals(pricePerOunce * (22 / 24)),
      basePrice20KOz: roundToTwoDecimals(pricePerOunce * (20 / 24)),
      basePrice18KOz: roundToTwoDecimals(pricePerOunce * (18 / 24)),
      basePrice16KOz: roundToTwoDecimals(pricePerOunce * (16 / 24)),
      basePrice14KOz: roundToTwoDecimals(pricePerOunce * (14 / 24)),

      date: today,
    };

    localStorage.setItem("goldPriceData", JSON.stringify(prices));
    return {
      "24K": {
        perGram: roundToTwoDecimals(pricePerGram24K),
        perOunce: roundToTwoDecimals(pricePerOunce)
      },
      "22K": {
        perGram: roundToTwoDecimals(pricePerGram22K),
        perOunce: roundToTwoDecimals(pricePerOunce * (22/24))
      },
      "20K": {
        perGram: roundToTwoDecimals(pricePerGram20K),
        perOunce: roundToTwoDecimals(pricePerOunce * (20/24))
      },
      "18K": {
        perGram: roundToTwoDecimals(pricePerGram18K),
        perOunce: roundToTwoDecimals(pricePerOunce * (18/24))
      },
      "16K": {
        perGram: roundToTwoDecimals(pricePerGram16K),
        perOunce: roundToTwoDecimals(pricePerOunce * (16/24))
      },
      "14K": {
        perGram: roundToTwoDecimals(pricePerGram14K),
        perOunce: roundToTwoDecimals(pricePerOunce * (14/24))  
      }
    };
  } catch (err) {
    console.error("Gold price fetch failed:", err);
    toast.error("Failed to fetch gold price.");
    return { "24K": { perGram: 0, perOunce: 0 }, "22K": { perGram: 0, perOunce: 0 }, "20K": { perGram: 0, perOunce: 0 } };
  }
};